<template>
  <div class="dlrVRBottomMenu" v-show="bottomCls">
    <div class="dlrVRBottomMenu-bg" :class="{nopb: busi === 'ics'}">
      <scene-list :sceneBtn="sceneBtn"></scene-list>
      <template v-if="busi === 'ics'">
        <BottomIcsApp
          :sceneBtn="sceneBtn"
          @toggleScene="toggleScene"
        />
      </template>
      <template v-else>
        <ul class="dlrVRBottomMenu-list">
          <li
            class="dlrVRBottomMenu-item"
            :class="{ active: activeIndex ===  1}"
            v-stat:show="{ action: 'dlr_vr_b_kehubiaoqian_show', extend: { channelId } }"
            v-stat:click="{ action: 'dlr_vr_b_kehubiaoqian_click', extend: { channelId } }"
            @click="showTestPop(1)"
          >
            <div class="dlrVRBottomMenu-icon">
              <em class="dlrVRBottomMenu-icon-customer"></em>
            </div>
            <div class="dlrVRBottomMenu-text">
              <p>客户标签</p>
            </div>
          </li>
          <li
            class="dlrVRBottomMenu-item"
            :class="{ active: activeIndex ===  2}"
            v-stat:show="{ action: 'dlr_vr_b_cheliangjieshao_show', extend: { channelId } }"
            v-stat:click="{ action: 'dlr_vr_b_cheliangjieshao_click', extend: { channelId } }"
            @click="showTestPop(2)"
          >
            <div class="dlrVRBottomMenu-icon">
              <em class="dlrVRBottomMenu-icon-intro"></em>
            </div>
            <div class="dlrVRBottomMenu-text">
              <p>车辆介绍</p>
            </div>
          </li>
          <li
            v-if="isShowIcon"
            class="dlrVRBottomMenu-item"
            :class="{ active: activeIndex ===  3}"
            v-stat:show="{ action: 'dlr_vr_b_youhuijieshao_show', extend: { channelId } }"
            v-stat:click="{ action: 'dlr_vr_b_youhuijieshao_click', extend: { channelId } }"
            @click="showTestPop(3)"
          >
            <div class="dlrVRBottomMenu-icon">
              <em class="dlrVRBottomMenu-icon-sales"></em>
            </div>
            <div class="dlrVRBottomMenu-text">
              <p>优惠介绍</p>
            </div>
          </li>
          <li
            class="dlrVRBottomMenu-item"
            :class="{ active: activeIndex ===  4}"
            v-stat:show="{ action: 'dlr_vr_b_yuyueshijia_show', extend: { channelId } }"
            v-stat:click="{ action: 'dlr_vr_b_yuyueshijia_click', extend: { channelId } }"
            @click="showTestPop(4)"
          >
            <div class="dlrVRBottomMenu-icon">
              <em class="dlrVRBottomMenu-icon-test"></em>
            </div>
            <div class="dlrVRBottomMenu-text">
              <p>预约试驾</p>
            </div>
          </li>
          <li
          v-stat:click="{
            action: 'dlr_vr_b_beizhu_click',
            extend: { channelId },
          }"
          v-stat:show="{
            action: 'dlr_vr_b_beizhu_show',
            extend: { channelId },
          }"
            :class="{ active: activeIndex === 5 }"
            class="dlrVRBottomMenu-item"
            @click="showTestPop(5)"
          >
          <div class="dlrVRBottomMenu-icon">
            <em class="dlrVRBottomMenu-icon-notes"></em>
          </div>
          <div class="dlrVRBottomMenu-text">
            <p>电话备忘</p>
          </div>
        </li>
        </ul>
        <div class="dlrVRBottomMenu-tips">
          <p>*该区域功能不会展示给客户</p>
        </div>
        <component
          :is="modalComponent"
          :jxs-buycar-purpow="jxsBuycarPurpow"
          :jxs-replace-demand="jxsReplaceDemand"
          :jxs-has-car="jxsHasCar"
          :jxs-buycar-intention="jxsBuycarIntention"
          :appeal-list="appealInfoList"
          :car-config="carConfig"
          :saleCarInfo="saleCarInfo"
          :ActivityPacketList="ActivityPacketList"
          :ActivityPacketAllList="ActivityPacketAllList"
          :specList="specList"
          :testIsClick="testIsClick"
          :form="form"
          @hide="hide"
          @send="send"
        ></component>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SceneList from '@/components/SceneList';
import IntentionPop from './IntentionPop.vue';
import SalesNotesPop from './SalesNotesPop.vue';
import icsApi from '@/apis/ics.api';
import vrShowApi from '@/apis/vr.show.api';
import orderButtonProxy from '../../../services/actionSync/order.button.proxy';
export default {
  components: {
    SceneList,
    BottomIcsApp: () => import(/* webpackChunkName: "BottomIcsApp" */'../../BottomIcsApp.vue'),
    IntentionPop,
    IntroPop: () => import(/* webpackChunkName: "IntroPop" */'./IntroPop.vue'),
    SalesPop: () => import(/* webpackChunkName: "SalesPop" */'./SalesPop.vue'),
    TestPop: () => import(/* webpackChunkName: "TestPop" */'./TestPop.vue'),
    SalesNotesPop,
  },
  props: {
    dealerId: {
      tpye: Number,
      default: 0
    }
  },
  data () {
    return {
      activeIndex: 0,
      jxsBuycarPurpow: '',
      jxsReplaceDemand: '',
      jxsHasCar: '',
      jxsBuycarIntention: '',
      appealInfoList: [],
      carConfig: {},
      saleCarInfo: {},
      ActivityPacketAllList: [],
      ActivityPacketList: [],
      specList: [],
      mapRedPackets: {},
      testIsClick: false,
      busi: this.$route.query.busi,
      sceneBtn: { selected: false },
      bottomCls: true,
      form:{}
    };
  },
  computed: {
    ...mapGetters('redPacket', { hasRedPacket: 'hasRedPacket', seriesDownPrice: 'seriesDownPrice' }),
    ...mapGetters({
      callStatus: 'callStatus/callStatus',
      'hideBottom': 'hideBottom',
      vrSalesInfo: 'sales/vrSalesInfo',
      userInfo: 'sales/userInfo'
    }),
    modalComponent () {
      let btnComponent = '';
      if (this.activeIndex === 1) {
        btnComponent = 'IntentionPop';
      } else if (this.activeIndex === 2) {
        btnComponent = 'IntroPop';
      } else if (this.activeIndex === 3) {
        btnComponent = 'SalesPop';
      } else if (this.activeIndex === 4) {
        btnComponent = 'TestPop';
      } else if (this.activeIndex === 5) {
        btnComponent = 'SalesNotesPop';
      }
      return btnComponent;
    },
    jxsShow () {
      return this.jxsBuycarIntention && this.jxsHasCar && this.jxsReplaceDemand && this.jxsBuycarPurpow;
    },
    isShowIcon () {
      return this.seriesDownPrice > 0 || this.hasRedPacket;
    },
    channelId () {
      return this.vrSalesInfo.channelId;
    }
  },
  created () {
    const realtimeanswer = this.$route.query.realtimeanswer;
    if (realtimeanswer) {
      const seriesId = this.$route.query.seriesId || 0;
      this.getCarConfig(seriesId);
      this.getActivityPacketList(seriesId);
      this.getCarYHInfo(seriesId);
      this.initGetPortrain();
      this.getActivityPacketAllList(this.dealerId);
      this.initOptPicListPromise();
      this.form = {
        customerName: this.userInfo?.userName,
        phone: ''
      };
    }
    this.$bus.$on('showTestPop', (index) => {
      this.showTestPop(index);
    })
  },
  methods: {
    toggleScene () {
      this.sceneBtn.selected = !this.sceneBtn.selected;
      this.$bus.$emit('icsToggleScene');
    },
    showTestPop (index) {
      if (this.activeIndex === index) {
        this.activeIndex = 0;
      } else {
        this.activeIndex = index;
      }
    },
    // 是否有红包和降价
    initGetPortrain () {
      const deviceId = this.$route.query.deviceId || '-1';
      icsApi.getPortrain(deviceId).then((res) => {
        if (res) {
          const data = res;
          this.jxsBuycarPurpow = data.jxsBuycarPurpow;
          this.jxsReplaceDemand = data.jxsReplaceDemand;
          this.jxsHasCar = data.jxsHasCar;
          this.jxsBuycarIntention = data.jxsBuycarIntention;
        }
      });
    },
    initOptPicListPromise () {
      this.$bus.$on('optPicListPromise', ({ channelId, channelName }) => {
        this.getAppealService(channelName, channelId);
      });
    },
    // 用户意向
    getAppealService (channelName, channelId) {
      vrShowApi.getAppeal(channelName, channelId).then((res) => {
        if (!res || res.appeal.length === 0 || !res.appeal) {
          this.appealInfoList = [];
        } else {
          this.appealInfoList = res.appeal;
        }
      }).catch((error) => {
        this.appealInfoList = [];
        console.error('initAppealInfo error: ', error);
      });
    },
    // 车辆介绍
    getCarConfig (seriesId) {
      icsApi.getCarConfig(seriesId).then((res) => {
        this.carConfig = res;
      });
    },
    // 优惠信息-获取车辆配置信息
    getCarYHInfo (seriesId) {
      icsApi.getCarYHInfo(seriesId, this.dealerId).then(res => {
        this.specList = res[0].specList;
        if(this.specList){
        this.saleCarInfo = {
          seriesId: res[0].seriesId,
          seriesName: res[0].seriesName,
          specId: res[0].specList.find((item) => item.maxPrice > 0).specId
        };
      }
      });
    },
    // 优惠信息-店内红包列表
    getActivityPacketAllList (dealerId) {
      icsApi.getActivityPacketAllList(dealerId).then(res => {
        res.forEach(element => {
          element.isSend = false;
        });
        this.ActivityPacketAllList = res;
      });
    },
    // 优惠信息-店内当前车系红包列表
    getActivityPacketList (seriesId) {
      icsApi.getActivityPacketList(this.dealerId, seriesId).then(res => {
        res.forEach(element => {
          element.isSend = false;
        });
        this.ActivityPacketList = res;
      });
    },
    // 任何弹层关闭后，样式初始化
    hide () {
      this.activeIndex = 0;
    },
    // 发送试驾邀请之后状态变更
    send () {
      this.testIsClick = true;
    },

  },
  watch: {
    hideBottom: {
      handler: function (newVal) {
        if (newVal) {
          this.bottomCls = false;
        } else {
          this.bottomCls = true;
        }
      },
      immediate: true
    },
  }
};
</script>
<style lang="scss">
@import 'VRSalerPop.scss';
</style>
